import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/deleteAkOdePosInsatallment',
      requesterInfo,
    })
  }

  public async deleteAkOdePosInsatallment(request: string): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?guid=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}

